import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _fa79c6fc = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _b2ff9660 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _11b4fae0 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _6aef307b = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _3c992537 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _20bb90a0 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _0d4cb8a8 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _c5ed4420 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _1b225632 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _46d49530 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _6a2995c6 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _3a81e1dd = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _350d94f0 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _ffeb5cc2 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _1f365580 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _5be6dd96 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _24f945e5 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _8ce25140 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _fa79c6fc,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _b2ff9660,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _11b4fae0,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _6aef307b,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _3c992537,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _20bb90a0,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _20bb90a0,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _20bb90a0,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _0d4cb8a8,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _c5ed4420,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _1b225632,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _c5ed4420,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _1b225632,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _46d49530,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _46d49530,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _46d49530,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _46d49530,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _46d49530,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _46d49530,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _46d49530,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _6a2995c6,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _6a2995c6,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _3a81e1dd,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _350d94f0,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _350d94f0,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _ffeb5cc2,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _1f365580,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _5be6dd96,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _5be6dd96,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _24f945e5,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _8ce25140,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
